<div class="td-cnt-ext">
    <div class="td-cnt" [ngClass]="{'td-cnt-mobile' : isMobile}" id="teiasoftDialog">
        <div class="td-cnt-title">
            <i *ngIf="dialogIcon != ''" class="{{dialogIcon}} dialog-icon"></i>
            <span class="te-title">{{dialogTitle}}</span>
        </div>
        <div class="td-cnt-body" [ngClass]="{'flex-col': display == 'column'}">
            <div class="td-cnt-form">
                <ng-container *ngFor="let item of dialogForm; let i=index">
                    <div class="dialog-row" *ngIf="item.visible" [ngClass]="{'dialog-row-column' : display == 'column', 'dialog-row-icon' : item.type == 'icon',
                         'dialog-row-full-width' : item.fullWidth}"   [style.gridColumn]="'span ' + (item.colSpan || 1)" >
                        <teiasoft-input *ngIf="item.type! == 'text' || item.type! == 'number'" [type]="item.type!"
                            [labelText]="item.labelText!" [isMobile]="isMobile" [maxLength]="item.maxLength!"
                            [isRequired]="item.isRequired!" [disabled]="item.disabled!" [value]="item.text!"
                            [showCreate]="item.showCreate!" [autoComplete]="(item.autoComplete ? true : false)"
                            [autoCompleteDataset]="item.autoCompleteDataset!"
                            [autoCompleteColumns]="item.autoCompleteColumns!"
                            [autoCompleteColumnsToHide]="item.autoCompleteColumnsToHide!" [anchor]="item.anchor"
                            [autoCompleteField]="item.autoCompleteField!" [columnsWidthPerc]="item.columnsWidthPerc!"
                            (onAutocompleteLinkClick)="onAutocompleteLinkClick($event)" [isValid]="item.isValid !== false"
                            style="width:100%" (onInput)="onInput($event, item.field!)"
                            (onFocusOut)="onInputFocusOut($event, item.field!)"
                            (onAutocompleteSelect)="onAutocompleteSelect($event)" [selectable]="item.selectable!"
                            [multiSelection]="item.multiSelection!"
                            (onAutocompleteSelectRows)="onAutocompleteSelectRows($event)"
                            (onAutocompleteInputChange)="onAutocompleteInputChange($event)"
                            (onAutocompleteRemoveElement)="onAutocompleteRemoveElement($event)"
                            [readOnly]="item.readOnly!" [tabIndex]="(action == 'create' ? i : 99)"
                            [roundDigits]="(item.roundDigits != undefined ? item.roundDigits : 2)"></teiasoft-input>

                        <teiasoft-select *ngIf="item.type! == 'select'" [labelText]="item.labelText!"
                            [isMobile]="isMobile" [isRequired]="item.isRequired!" [disabled]="item.disabled!"
                            [optionsList]="item.optionsList!" [spaceLabel]="true" [noMinWidth]="true"
                            [isValid]="item.isValid !== false" [defaultValue]="item.value!"
                            (onSelected)="onSelected($event, item.field!)" style="width:100%"
                            [readOnly]="item.readOnly!"></teiasoft-select>

                        <teiasoft-button *ngIf="item.type! == 'button'" [type]="'tb-primary'" [text]="item.labelText!"
                            [disabled]="item.disabled!" [theme]="theme" [isMobile]="isMobile"
                            (onClick)="onClickFormButton(item.field!)" style="margin-top:5vh"></teiasoft-button>

                        <teiasoft-datetime *ngIf="item.type! == 'date' || item.type! == 'datetime'"
                            [value]="item.value!" [labelText]="item.labelText!" [type]="item.type!"
                            [isRequired]="item.isRequired!" [disabled]="item.disabled!" [isMobile]="isMobile"
                            [isValid]="item.isValid !== false" [dateFormat]="globals!.dateFormat!"
                            (onChange)="onChangeDate($event, item.field!)" style="width:100%"
                            [tabIndex]="(action == 'edit' ? 0 : 99)" [readOnly]="item.readOnly!" [minDate]="item.minDate!" [maxDate]="item.maxDate!"></teiasoft-datetime>

                        <teiasoft-emptyfield *ngIf="item.type! == 'emptyField'"></teiasoft-emptyfield>

                        <teiasoft-list *ngIf="item.type! == 'list'" [labelText]="item.labelText!" [isMobile]="isMobile"
                            [isRequired]="item.isRequired!" [disabled]="item.disabled!" [value]="item.value!"
                            [optionsList]="item.optionsList!" [isValid]="item.isValid !== false" style="width:100%"
                            (onSelect)="onSelectList($event, item.field!)"></teiasoft-list>

                        <teiasoft-toolbar *ngIf="item.type == 'toolbar'" [buttonsList]="item.toolbarButtonsList!"
                            [theme]="theme!" (onBtnClick)="onBtnToolbarClick($event)" style="width: 100%;"
                            style="margin-top:4vh;"></teiasoft-toolbar>

                        <teiasoft-toggle *ngIf="item.type == 'toggle'" [theme]="theme!"
                            (onToggleChanged)="onToggleChanged($event)" [labelText]="item.labelText!"
                            [isOn]="item.value!" [name]="item.field!"></teiasoft-toggle>

                        <i *ngIf="item.type == 'icon'" class="{{item.value!}} ico-dialog-form"></i>
                    </div>
                </ng-container>
            </div>
            <div class="td-cnt-att" (dragover)="onDragOver($event)" (drop)="onDropFile($event)"
            (dragleave)="onDragLeave($event)">
                <span class="bold" style="font-size: 2.4vh;margin-top: 1vh;"><i
                        class="fal fa-paperclip mr-5"></i>{{'enquiryBook.attachment' | translate}}</span>
                <div class="td-cnt-att-list">
                    <span *ngIf="!enquiryAttachments || enquiryAttachments!.length == 0"
                        class="no-data">{{'enquiryBook.noData' | translate}}</span>
                    <!-- ATTACHMENTS OF THE ITEM -->
                    <div *ngIf="enquiryAttachments && enquiryAttachments!.length" class="cnt-attach">
                        <div *ngFor="let item of enquiryAttachments" class="row-attach"
                            [ngClass]="{'is-in-deletion' : isInDeletion(item.enquiryAttachmentId!)}">
                            <span *ngIf="!item.presignedUrl || item.presignedUrl == ''"><i
                                    class="{{getFileIcoType(item)}} mr-5"></i>{{item.fileName}}</span>
                            <span *ngIf="item.presignedUrl && item.presignedUrl != ''" class="attach-link"
                                (click)="onOpenAttach(item)"><i
                                    class="{{getFileIcoType(item)}} mr-5"></i>{{item.fileName}}</span>
                            <span>{{item.fileDate | date:globals.dateTimeFormat}}</span>
                            <div *ngIf="!isInDeletion(item.enquiryAttachmentId!)" class="btn-delete-attach"
                                (click)="onDeleteAttachClick(item)">
                                <i class="fal fa-trash-alt mr-5"></i><span>{{'commons.delete' | translate}}</span>
                            </div>
                            <div *ngIf="isInDeletion(item.enquiryAttachmentId!)" class="btn-delete-attach"
                                (click)="onCancelDeleteClick(item.enquiryAttachmentId!)">
                                <i class="fal fa-times mr-5"></i><span>{{'commons.cancel' | translate}}</span>
                            </div>
                        </div>
                    </div>
                    <!-- NEW ATTACHMENTS -->
                    <div *ngIf="attachmentsToUpdate && attachmentsToUpdate.length > 0" class="cnt-attach">
                        <div *ngFor="let item of attachmentsToUpdate" class="row-attach">
                            <span><i class="{{getFileIcoType(item)}} mr-5"></i>{{item.fileName}}</span>
                            <span style="word-break: break-word;">{{item.fileCreationDate |
                                date:globals.dateTimeFormat}}</span>
                            <div class="btn-delete-attach" (click)="onDeleteAttachToUpdateClick(item)">
                                <i class="fal fa-trash-alt mr-5"></i><span>{{'commons.delete' | translate}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="isDragging" class="drop-zone-overlay">
                    <p>{{ 'commons.dropHere' | translate }}</p>
                </div>
            </div>
        </div>
        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
            <input type="file" class="file-upload" (change)="onFileSelectedAttach($event)" style="display: none;"
                id="fileUploadAttach">

            <teiasoft-button *ngFor="let item of dialogButtons" [text]="item.text!" [theme]="theme"
                [disabled]="item.disabled!" [isMobile]="isMobile" (onClick)="onDialogButtonClick(item.action)"
                [type]="item.buttonType!" class="ml-5" [secondaryActionIcon]="item.secondaryActionIcon"
                [ngClass]="{'hide-me' : item.visible == false}" (onSecondaryActionClick)="onDialogButtonClick(item.secondaryAction)"></teiasoft-button>
        </div>
    </div>
</div>
